import { utils } from '@yola/ws-color-rules';
import { PALETTE_KEY, COMMON_COLOR_TYPES_ORDER } from '../constants/common';

const initAssignVariable = (config) => (targetColor) => {
  const { cssVariablesMap, palettes, whiteColor, blackColor, advancedColors } = config;
  if (targetColor.strictlyEquals(blackColor, false)) {
    return `var(${cssVariablesMap.black})`;
  }

  if (targetColor.strictlyEquals(whiteColor, false)) {
    return `var(${cssVariablesMap.white})`;
  }

  const { shade, selectedColorType } = COMMON_COLOR_TYPES_ORDER.reduce((acc, currentType) => {
    if (acc.shade) return acc;

    acc.shade = utils.findColorShadeInPalette(
      targetColor,
      palettes[`${currentType}${PALETTE_KEY}`],
      false
    );
    acc.selectedColorType = currentType;
    return acc;
  }, {});

  if (shade) {
    return `var(${cssVariablesMap[selectedColorType][shade]})`;
  }

  if (
    Object.values(advancedColors).some((advancedColor) =>
      targetColor.strictlyEquals(advancedColor, false)
    )
  ) {
    return targetColor.toColorString();
  }

  // eslint-disable-next-line no-console
  console.warn(
    'Fallback triggered. Cannot find color shade in palette and advanced colors. Params',
    {
      palettes,
      whiteColor,
      blackColor,
      targetColor,
      advancedColors,
    }
  );
  return targetColor.toColorString();
};

export default initAssignVariable;
